import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const StoreSymbol = Symbol.for('Store');

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
});
